import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { checkoutStepDefinition } from "../CheckoutPage/CheckoutStartup";
import { UpgradeBookingInitStepDeclaration } from "./Steps/UpgradeBookingInitStep";
import { UpgradeBookingTransition } from "./Transition/UpgradeBookingTransition";

export const upgradeBookingStartupFlow = new FlowDefinition("UpgradeBookingFlow");

upgradeBookingStartupFlow.addStep(UpgradeBookingInitStepDeclaration);
upgradeBookingStartupFlow.addStep(checkoutStepDefinition);

upgradeBookingStartupFlow.addLink("UpgradeBookingInit_Step", "CheckoutFlow")

upgradeBookingStartupFlow.addTransition(UpgradeBookingTransition, "UpgradeBookingInit_Step")

upgradeBookingStartupFlow.setStartStep("UpgradeBookingInit_Step");

export const upgradeBookingStepDefinition = new StepDefinition({
    stepName: "UpgradeBookingFlow",
    stepFlow: upgradeBookingStartupFlow,
    contextIsolation: false
})
